import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const DeliverByDate = {
  id: 'deliverByDate',
  displayName: <FormattedMessage {...messages.deliverByDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON,
  filterValue: 'DeliverByDateTime',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON, criteriaInformations);
  },
};
